export default __webpack_public_path__ + "static/media/Mastercard-logo.cf40a315.svg";